import {PRODUCT_TYPE} from "../../helpers/payment/constants"

const defaultState = () => ({
  productType: PRODUCT_TYPE.IMAGE_PROCESSING,
  productData: {
    name: "Processamento 1",
    description: "Descrição Proc 1",
  },
})
const state = defaultState()

// -------------- Mutations -------------- //
const MUTATIONS_TYPES = {
  SET_PAYMENT_DATA: "SET_PAYMENT_DATA",
  CLEAN_PAYMENT: "CLEAN_PAYMENT",
}

const mutations = {
  [MUTATIONS_TYPES.SET_PAYMENT_DATA](state, paymentData) {
    const {productType, productData} = paymentData
    state.productType = productType
    state.productData = productData
  },
  [MUTATIONS_TYPES.CLEAN_PAYMENT](state) {
    Object.assign(state, defaultState())
  },
}

// -------------- Getters -------------- //
export const GET_PRODUCT_TYPE = "GET_PRODUCT_TYPE"
export const GET_PRODUCT_DATA = "GET_PRODUCT_DATA"

const getters = {
  [GET_PRODUCT_TYPE](state) {
    return state.productType
  },
  [GET_PRODUCT_DATA](state) {
    return state.productData
  },
}

// -------------- Actions -------------- //
export const SET_PAYMENT_DATA = "SET_PAYMENT_DATA"
export const CLEAN_PAYMENT = "CLEAN_PAYMENT"

const actions = {
  [SET_PAYMENT_DATA]({commit}, paymentData) {
    commit(MUTATIONS_TYPES.SET_PAYMENT_DATA, paymentData)
  },
  [CLEAN_PAYMENT]({commit}) {
    commit(MUTATIONS_TYPES.CLEAN_PAYMENT)
  },
}

export default {
  mutations,
  getters,
  actions,
  state,
}
